import { Button } from '@tremor/react';
import { ComponentProps } from 'react';
import { ClipLoader } from 'react-spinners';

type Props = ComponentProps<typeof Button> & { isLoading?: boolean };

export function SubscriptionButton({
  children,
  isLoading,
  disabled,
  className,
  ...props
}: Props) {
  return (
    <Button
      className={[
        className,
        'relative bg-gradient-to-br from-primary-default to-primary-500 rounded-xl py-[0.6125rem] px-4 font-bold text-center cursor-pointer border-0 w-[300px] h-fit shadow-[0_4px_6px_rgba(222,42,72,0.25)] transition-transform duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-4 disabled:bg-primary-400 disabled:opacity-60 disabled:cursor-not-allowed disabled:scale-100 disabled:focus:ring-0 [&_p]:text-lg',
      ].join(' ')}
      {...props}
      disabled={isLoading || disabled}
    >
      {isLoading ? <ClipLoader color="#fff" speedMultiplier={0.9} size={24} /> : children}
    </Button>
  );
}
